<template>
  <div class="auto_css" id="myElement">
    <div class="section1 section" id="section1">
      <img class="aboutbg1 pc" :src="require('@/assets/img/gamebg1.png')" />
      <img class="aboutbg1 h5" :src="require('@/assets/imgh5/gamebg1.png')" />

      <div class="top-font top-font1">产品</div>
      <div class="ct-font">
        <div>JIUWAN GAMES</div>
      </div>
      <div class="top-font top-font2">中心</div>
    </div>
    <div class="section2 section" id="section2">
      <img class="aboutbg2 pc" :src="require('@/assets/img/gamebg2.png')" />
      <!-- <img class="aboutbg2 h5" :src="require('@/assets/imgh5/gamebg2.png')" /> -->

      <div class="contain">
        <!-- pc -->
        <div
          v-for="(item, index) in showPcList"
          :key="index"
          class="game-item pc"
        >
          <div style="width: 100%; display: flex">
            <div class="g-left">
              <div class="gl-top">
                <img class="glicon" :src="item.game_icon" />
                <div class="name">{{ item.game_name }}</div>
              </div>

              <div
                class="gl-btn"
                v-if="item.game_url"
                @click="handlGo(item.game_url)"
              >
                进入官网
              </div>
            </div>
            <div class="g-right">
              <img class="h-game" :src="item.game_banner2" />
            </div>
          </div>
        </div>
        <!-- 下方切换按钮 -->
        <div class="swiper-btn">
          <img
            class="s-btn prev pc"
            :class="pcPage == 1 ? 'noneGo' : ''"
            :src="require('@/assets/img/left.png')"
            @click="handlePrev"
          />
          <img class="line1 pc" :src="require('@/assets/img/line1.png')" />
          <img
            class="s-btn next pc"
            :class="pcPage == totalPage ? 'noneGo' : ''"
            :src="require('@/assets/img/right.png')"
            @click="handleNext"
          />
        </div>

        <!-- h5  -->
        <div
          v-for="(item, index) in gameList"
          :key="index"
          class="game-item h5"
        >
          <div style="width: 100%; display: flex">
            <div class="g-left">
              <div class="gl-top">
                <img class="glicon" :src="item.game_icon" />
                <div class="name">{{ item.game_name }}</div>
              </div>

              <div
                class="gl-btn"
                v-if="item.game_url"
                @click="handlGo(item.game_url)"
              >
                进入官网
              </div>
            </div>
            <div class="g-right">
              <img class="h-game" :src="item.game_banner2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
const store = useStore();
store.commit("setLoad", true);
const { proxy } = getCurrentInstance();
// pc展示的游戏列表4个
const pcPage = ref(1);
const totalPage = ref(1);
const gameList = ref([]);
const showPcList = ref([]);
const webId = ref();
// 初始化
const initData = async () => {
  return new Promise((reslove) => {
    let params = {
      host: window.location.host,
    };
    proxy.$axios.post("/Index/initData", params).then(async (res) => {
      if (res.code == 200) {
        webId.value = res.data.company_id;
        await getGame();
        reslove();
      }
    });
  });
};
initData();
// 获取游戏轮播
const getGame = async () => {
  return new Promise((reslove) => {
    let params = {
      company_id: webId.value,
      type: "list",
    };
    proxy.$axios.post("/Index/getGames", params).then((res) => {
      if (res.code == 200) {
        gameList.value = res.data;
        totalPage.value = Math.ceil(gameList.value.length / 6);
        getPcList();
        reslove();
      }
    });
  });
};
// pc展示哪些游戏
const getPcList = () => {
  // showPcList.value = [];
  let list = [];
  if (gameList.value[(pcPage.value - 1) * 6]) {
    list.push(gameList.value[(pcPage.value - 1) * 6]);
  }
  if (gameList.value[(pcPage.value - 1) * 6 + 1]) {
    list.push(gameList.value[(pcPage.value - 1) * 6 + 1]);
  }
  if (gameList.value[(pcPage.value - 1) * 6 + 2]) {
    list.push(gameList.value[(pcPage.value - 1) * 6 + 2]);
  }
  if (gameList.value[(pcPage.value - 1) * 6 + 3]) {
    list.push(gameList.value[(pcPage.value - 1) * 6 + 3]);
  }
  if (gameList.value[(pcPage.value - 1) * 6 + 4]) {
    list.push(gameList.value[(pcPage.value - 1) * 6 + 4]);
  }
  if (gameList.value[(pcPage.value - 1) * 6 + 5]) {
    list.push(gameList.value[(pcPage.value - 1) * 6 + 5]);
  }
  showPcList.value = list;
};
// pc下方按钮点击
const handlePrev = () => {
  if (pcPage.value == 1) return;
  pcPage.value = pcPage.value - 1;
  getPcList();
};
const handleNext = () => {
  if (pcPage.value == totalPage.value) return;
  pcPage.value = pcPage.value + 1;
  getPcList();
};
const handlGo = (url) => {
  window.location = url;
};
onMounted(() => {
  store.commit("setLoad", false);
});
onUnmounted(() => {});
</script>
<style src="./game.css" scoped></style>
<style scoped>
</style>
